import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Truck, ShieldCheck } from 'lucide-react';
export function TrustSection() {
  return <section className="w-full bg-dark-800 py-24 px-4" data-id="element-145">
      <div className="max-w-5xl mx-auto" data-id="element-146">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-147">
          {/* Shipping */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-start" data-id="element-148">
            <div className="flex items-center gap-3 mb-4" data-id="element-149">
              <Truck className="w-8 h-8 text-gold-500" data-id="element-150" />
              <h3 className="text-2xl font-bold text-white" data-id="element-151">
                Envío gratis a todo el país
              </h3>
            </div>
            <p className="text-gray-400 leading-relaxed" data-id="element-152">
              Despachamos en{' '}
              <strong className="text-white" data-id="element-153">48 horas hábiles</strong>. Embalaje
              discreto sin identificación del producto.
            </p>
          </motion.div>

          {/* Guarantee */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-start" data-id="element-154">
            <div className="flex items-center gap-3 mb-4" data-id="element-155">
              <ShieldCheck className="w-8 h-8 text-gold-500" data-id="element-156" />
              <h3 className="text-2xl font-bold text-white" data-id="element-157">
                180 días de garantía
              </h3>
            </div>
            <p className="text-gray-400 leading-relaxed" data-id="element-158">
              Si no te convence o tenés algún problema, lo cambiamos sin
              vueltas. Queremos que compres con confianza.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-159">
          <Button className="w-full md:w-auto min-w-[300px]" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-160">
            Comprar ahora (Envío gratis)
          </Button>
        </motion.div>
      </div>
    </section>;
}